<template>
	<div class="cm-list-error">
		<div class="card">
			<div class="card-body">
				<h2>Keine Fahrzeuge gefunden</h2>
				<p>Ihre Suche ergab keine Treffer</p>
				<button
					type="button"
					class="btn btn-white me-2"
					@click="deleteLastFilter"
				>
					<i class="mdi mdi-filter-minus"></i> Letzten Filter löschen
				</button>
				<button type="button" class="btn btn-white" @click="deleteAllFilter">
					Neue Suche <i class="mdi mdi-restore"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'ListItemError',
	methods: {
		deleteLastFilter() {
			store.commit('deleteFilter', store.state.lastFilter)
			this.$emit('updateFilter')
		},
		deleteAllFilter() {
			store.commit('deleteAllFilter')
			this.$emit('updateFilter')
		},
	},
}
</script>

<style scoped></style>
